import { useNavigate } from "react-router";
import { Screen } from "../PodContext";
import Button from "./Button";
import "./Disclaimer.css";
import DisclaimerText from "./DisclaimerText";
import Footer from "./Footer";
import GoHomeTimer from "./GoHomeTimer";
import Header from "./Header";

const Disclaimer = () => {
  const navigate = useNavigate();

  return (
    <div className="image-bg-container">
      <GoHomeTimer />
      <Header totalSteps={4} title="Disclaimer" progress={1} />
      <div className="pod-disclaimer-container">
        <div className="pod-disclaimer-scroll">
          <div>
            <DisclaimerText />
          </div>
        </div>
        <div className="text-center">
          <Button
            text="I agree"
            filled
            onClick={() => navigate(Screen.PRE_FEELING)}
          />
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default Disclaimer;
